const Partners = () => {
  const partList = [
    "/images/part1.webp",
    "/images/part2.webp",
    "/images/part3.webp",
    "/images/part4.webp",
    "/images/part5.webp",
    "/images/part6.webp",
    "/images/part7.webp",
    "/images/part8.webp",
    "/images/part9.webp",
    "/images/part10.webp",
    "/images/part11.webp",
    "/images/part12.webp",
    "/images/part13.webp",
    "/images/part14.webp",
    "/images/part15.webp",
    "/images/part16.webp",
    "/images/part17.webp",
    "/images/part18.webp",
    "/images/part19.webp",
    "/images/part20.webp",
    "/images/part21.webp",
    "/images/part22.webp",
    "/images/part23.webp",
    "/images/part24.webp",
    "/images/part25.webp",
    "/images/part26.webp",
    "/images/part27.webp",
    "/images/part28.webp",
    "/images/part29.webp",
    "/images/part30.webp",
    "/images/part31.webp",
    "/images/part32.webp",
    "/images/part33.webp",
    "/images/part34.webp",
    "/images/part35.webp",
  ];

  return (
    <div
      id="partners"
      className="relative w-full h-full py-14 lg:py-28 px-[calc((100%-var(--container))/2)]"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-14"
      >
        <h3 className="font-normal">거래처 및 협력사</h3>
        <p className="text-primary my-5 lg:text-lg">
          - Business partners and partners  -
        </p>
      </div>
      <div className=" relative w-full h-full py-10 grid grid-cols-2 lg:grid-cols-5 gap-2 lg:gap-5">
        {partList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            className="relative w-full h-full border border-black px-1 py-2"
          >
            <img
              className="!relative w-auto max-w-32 h-20 mx-auto object-contain"
              alt={`카이노스 바이오케미칼 거래처 및 협력사 로고 ${i + 1}`}
              src={v}
              width={500}
              height={500}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Partners;
